/*
 * Copyright (c) 2018-2999 广州市蓝海创新科技有限公司 All rights reserved.
 *
 * https://www.mall4j.com/
 *
 * 未经允许，不可做商业用途！
 *
 * 版权所有，侵权必究！
 */

import http from './http.js'
import * as cartCount from './cart-count.js'
import { AppType, PayType } from './constant.js'
import Big from 'big.js'
import { checkAuthorize } from '@/utils/authorize/index.js'
// #ifdef H5
import media from '@/static/audio/media.mp3'
// #endif
import { getPaySettlementTypeConfig, getShopHeaderInfo, getShopRenovationDetail, getDistributionSysConfig } from '@/api/modules/mall4cloud_admin.js'
import { getProdDetail } from '@/api/modules/mall4cloud_product.js'
import { getDistributionUserInfo } from '@/api/modules/mall4cloud_marketing.js'
import { getUserDetailInfo, triggerCostPerPopup } from '@/api/modules/mall4cloud_user.js'
import { loginBySocialMa, loginBySocialMp, refreshAccessToken } from '@/api/modules/mall4cloud_auth.js'
import { getAllinpayMemberInfo, createAllinpayMember } from '@/api/modules/mall4cloud_payment.js'
import { listAreaOptions, listAreaByParentId } from '@/api/modules/mall4cloud_order.js'
import { getUploadMinioOptions } from '@/api/modules/mall4cloud_biz.js'
import { apiRequest } from '@/api/request.js'
import { handleRequestError } from '@/api/error.js'
import { FLASH_PRODUCT_DETAIL_ROUTE, PRODUCT_DETAIL_ROUTE, toProductDetailUrl } from '@/utils/routes.js'
const wxs = number()
const tid = uni.getStorageSync('cloudTid')
const normalizeUsageValue = usage => {
  if (usage === undefined || usage === null || usage === '') {
    return ''
  }
  return Number(usage) === 2 ? '2' : '1'
}
const normalizeTabBarRoute = url => String(url || '').split('?')[0].replace(/^\/+/, '')
const getTabBarUsageStorageKey = url => `cloudPendingTabBarUsage:${normalizeTabBarRoute(url)}`
const appendQueryParam = (url, key, value) => {
  if (!url || value === undefined || value === null || value === '') {
    return url
  }
  const hashIndex = url.indexOf('#')
  const hash = hashIndex > -1 ? url.slice(hashIndex) : ''
  const baseUrl = hashIndex > -1 ? url.slice(0, hashIndex) : url
  const reg = new RegExp(`([?&])${key}=`)
  if (reg.test(baseUrl)) {
    return url
  }
  return `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}${key}=${encodeURIComponent(value)}${hash}`
}
const appendTidIfNeeded = (url, domain) => {
  if (uni.getStorageSync(domain)) {
    return url
  }
  return appendQueryParam(url, 'tid', tid)
}
const util = {
  /*
   * Copyright (c) 2018-2999 广州市蓝海创新科技有限公司 All rights reserved.
   *
   * https://www.mall4j.com/
   *
   * 未经允许，不可做商业用途！
   *
   * 版权所有，侵权必究！
   */
  formatTime: date => {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()
    return [year, month, day].map(util.formatNumber()).join('/') + ' ' + [hour, minute, second].map(util.formatNumber()).join(':')
  },
  formatNumber: n => {
    n = n.toString()
    return n[1] ? n : '0' + n
  },
  formatHtml: content => {
    if (!content) {
      return ''
    }
    content = content.replace(/<!--(.+)-->/gi, '')
    content = content.replace(/class=/gi, 'sss=')
    content = content.replace(/<p/gi, '<p style="max-width:100% !important;word-wrap:break-word;word-break:break-word;" ')
    content = content.replace(/<img/gi, '<img style="max-width:100% !important;margin:0;display:inline-block !important; vertical-align:middle;" ')
    content = content.replace(/style="/gi, 'style="max-width:100% !important;table-layout:fixed;word-wrap:break-word;word-break:break-word;')
    content = content.replace(/<table/gi, '<table style="table-layout:fixed;word-wrap:break-word;word-break:break-word;" ')
    content = content.replace(/<td/gi, '<td cellspacing="0" cellpadding="0" style="border-width:1px; border-style:solid; border-color:#666; margin: 0px; padding: 0px;"')
    content = content.replace(/<video/gi, '<video style="width:100% !important;height:auto !important;margin:0;display:flex;" ')
    return content
  },
  endOfStartTime: (startTime, endTime) => {
    let result = {
      day: '00',
      hou: '00',
      min: '00',
      sec: '00',
      signs: 0
    }
    if (endTime - startTime > 0) {
      const time = (endTime - startTime) / 1000 // 获取天、时、分、秒
      const day = parseInt(time / (60 * 60 * 24))
      const hou = parseInt(time % (60 * 60 * 24) / 3600)
      const min = parseInt(time % (60 * 60 * 24) % 3600 / 60)
      const sec = parseInt(time % (60 * 60 * 24) % 3600 % 60)
      result = {
        day: `${util.timeFormat(day)}`,
        hou: `${util.timeFormat(hou)}`,
        min: `${util.timeFormat(min)}`,
        sec: `${util.timeFormat(sec)}`,
        signs: 1
      }
    }
    return result
  },
  // 页面跳转
  // eslint-disable-next-line max-lines-per-function
  toRedirectLink: async (type, link, shopId, isShop = 'shop', usage) => {
    const pages = getCurrentPages()
    const curPageRoute = pages[pages.length - 1].route // 当前页面url
    const domain = util.getDomain()
    const normalizedUsage = normalizeUsageValue(usage)
    let newUrl = ''
    const mobileLoginList = [
    // 移动端页面内容 需要登录的页面
      '/package-user/pages/order/order?orderStatus=0', '/package-activities/pages/my-collection/my-collection', '/package-activities/pages/integral-mall/integral-mall', '/package-activities/pages/member-center-general/member-center-general', '/package-activities/pages/distribution-center/distribution-center', '/package-activities/pages/sign-in/sign-in']
    const linkUrl = link && typeof link === 'object' ? link.url : ''

    // 以上页面未登录会跳转到登录页
    if ((type == 4 || type == 6) && (mobileLoginList.indexOf(link) > -1 || (linkUrl && mobileLoginList.indexOf(linkUrl) > -1))) {
      const inx = mobileLoginList.indexOf(link) > -1 ? mobileLoginList.indexOf(link) : mobileLoginList.indexOf(linkUrl)
      if (inx === 4) {
        // 跳转的为分销页面
        const distSwitch = await util.getDistSwitch()
        if (!distSwitch) {
          uni.showToast({
            title: '分销功能已关闭，请咨询平台',
            icon: 'none'
          })
          return
        }
      }
      // 登录后的回跳地址
      util.checkAuthInfo(async () => {}, appendQueryParam(mobileLoginList[inx], 'usage', normalizedUsage))
      if (!uni.getStorageSync('cloudToken')) return
    }
    switch (type) {
      case '1':
        // 跳转到商品
        if (await util.checkProdStatus(link)) {
          uni.navigateTo({
            url: appendTidIfNeeded(toProductDetailUrl('spuId=' + link + (normalizedUsage ? '&usage=' + normalizedUsage : '')), domain)
          })
        }
        break
      case '2':
        // 跳转到分类
        if (Array.isArray(link)) {
          uni.navigateTo({
            url: appendQueryParam(appendTidIfNeeded(`/package-activities/pages/search-list/search-list?cid=${link[2]?.value || ''}&cName=${link[2]?.label || ''}&cid2=${link[1]?.value || ''}&categoryList=${JSON.stringify(link)}`, domain), 'usage', normalizedUsage)
          })
        } else {
          uni.navigateTo({
            url: appendQueryParam(appendTidIfNeeded(`/package-shop/shop-page/shop-prods/shop-prods?secondCategoryId=${link[1].value}&categoryName=${link[1].label}`, domain), 'usage', normalizedUsage)
          })
        }
        break
      case '3':
        // 跳转到店铺
        if (isShop === 'shop') {
          let url = ''
          // eslint-disable-next-line no-case-declarations
          const storeRes = await util.getShopMessage(link)
          // eslint-disable-next-line no-case-declarations
          if (storeRes.renovationId) {
            url = '/package-shop/shop-page/feature-index/feature-index?shopId=' + link + '&renovationId=' + storeRes.renovationId + (uni.getStorageSync(domain) ? '' : '&tid=' + tid)
          } else {
            url = '/package-shop/shop-page/shop-index/shop-index?shopId=' + link + (uni.getStorageSync(domain) ? '' : '&tid=' + tid)
          }
          uni.navigateTo({
            url: appendQueryParam(url, 'usage', normalizedUsage)
          })
        } else {
          uni.navigateTo({
            url: appendQueryParam(appendTidIfNeeded('/package-shop/pages/shop-station/shop-station?stationId=' + link, domain), 'usage', normalizedUsage)
          })
        }
        break
      case '4':
        // 跳转到页面
        // eslint-disable-next-line no-case-declarations
        const generalMemberUrl = 'package-activities/pages/member-center-general/member-center-general' // 普通会员页面
        // eslint-disable-next-line no-case-declarations
        const memberUrl = 'package-activities/pages/member-center/member-center' // 付费会员
        if ((curPageRoute === generalMemberUrl || curPageRoute === memberUrl) && link === '/' + generalMemberUrl) return
        if (mobileLoginList.indexOf(link) > -1) {
          if (link === '/package-activities/pages/distribution-center/distribution-center') {
            // 用户跳转去分销中心
            util.handleDistRedirect(appendQueryParam(link, 'usage', normalizedUsage))
          } else {
            uni.navigateTo({
              url: appendQueryParam(appendTidIfNeeded(link, domain), 'usage', normalizedUsage)
            })
          }
        } else {
          if (link === '/package-shop/pages/feature-index/feature-index') {
            const pages = getCurrentPages()
            const curPage = pages[pages.length - 1].$page.path
            const store = await util.getShopMessage(shopId)
            let url
            if (store.renovationId) {
              // 如果跳转的页面是当前页面时，则停止跳转
              if (curPage === '/package-shop/shop-page/feature-index/feature-index') return
              url = '/package-shop/shop-page/feature-index/feature-index?shopId=' + shopId + '&renovationId=' + store.renovationId
            } else {
              // 如果跳转的页面是当前页面时，则停止跳转
              if (curPage === '/package-shop/shop-page/shop-index/shop-index') return
              url = '/package-shop/shop-page/shop-index/shop-index?shopId=' + shopId
            }
            uni.navigateTo({
              url: appendQueryParam(appendTidIfNeeded(url, domain), 'usage', normalizedUsage)
            })
          } else {
            // if (link === '/pages/cart/cart' || link === '/pages/my/my' || link === '/pages/live-broadcast/live-broadcast' || link === '/pages/index/index') {
            if (link === '/pages/cart/cart' || link === '/pages/my/my' || link === '/pages/index/index') {
              if (normalizedUsage) {
                uni.setStorageSync(getTabBarUsageStorageKey(link), normalizedUsage)
              } else {
                uni.removeStorageSync(getTabBarUsageStorageKey(link))
              }
              uni.switchTab({
                url: link
              })
            } else if (link !== '/pages/live-broadcast/live-broadcast') {
              uni.navigateTo({
                url: appendQueryParam(appendTidIfNeeded(link, domain), 'usage', normalizedUsage)
              })
            }
          }
        }
        break
      case '5':
        // 跳转到微页面
        if (+shopId === 0 || shopId) {
          const pageInfo = await util.getRenovationInfo(link, shopId)
          if (+shopId === 0 && pageInfo.homeStatus === 1) return
          if (!pageInfo) {
            uni.showToast({
              icon: 'none',
              title: '页面不存在！'
            })
            return
          }
        }
        uni.navigateTo({
          url: appendQueryParam(appendTidIfNeeded('/pages/feature-index/feature-index?renovationId=' + link + '&shopId=' + shopId, domain), 'usage', normalizedUsage)
        })
        break
      case '6':
        // 跳转到自定义链接
        newUrl = link.url || link
        if (newUrl === '/') return
        // eslint-disable-next-line no-case-declarations
        const reg1 = /^\//
        // eslint-disable-next-line no-case-declarations
        const reg2 = /^(http|https)/
        if (reg1.test(newUrl)) {
          // 如果是以 / 开头
          let isStatus = false
          uni.navigateTo({
            url: appendQueryParam(appendTidIfNeeded(newUrl, domain), 'usage', normalizedUsage),
            success: function () {},
            fail: function () {},
            complete: function (val) {
              if (val.path === '/') {
                isStatus = true
              }
            }
          })
          setTimeout(() => {
            if (isStatus) {
              uni.showToast({
                icon: 'error',
                title: '跳转链接异常'
              })
            }
          }, 100)
        } else if (reg2.test(newUrl)) {
          // 否则以http开头
          // #ifdef H5
          location.href = newUrl
          // #endif
          // #ifdef MP-WEIXIN
          const url = encodeURIComponent(newUrl)
          uni.navigateTo({
            url: '/pages/web-view/web-view?url=' + url + (uni.getStorageSync(domain) ? '' : '&tid=' + tid)
          })
          // #endif
          // #ifdef APP-PLUS
          // eslint-disable-next-line no-undef
          plus.runtime.openURL(newUrl)
          // #endif
        } else {
          uni.showToast({
            icon: 'error',
            title: '跳转链接异常'
          })
        }
        break
      default:
        break
    }
  },
  consumePendingTabBarUsage (url) {
    const storageKey = getTabBarUsageStorageKey(url)
    const usage = normalizeUsageValue(uni.getStorageSync(storageKey))
    uni.removeStorageSync(storageKey)
    return usage
  },
  // 查询改装修是否为主页
  getRenovationInfo (renovationId, shopId) {
    return new Promise(async resolve => {
      try {
        const res = await getShopRenovationDetail({
          data: {
            renovationId,
            shopId
          }
        })
        resolve(res)
      } catch (error) {
                  resolve(-1)
      }
    })
  },
  // 判断商品是否下架
  checkProdStatus (spuId) {
    const userId = uni.getStorageSync('cloudToken') && uni.getStorageSync('cloudUserDetails') ? uni.getStorageSync('cloudUserDetails').userId : undefined
    return new Promise(async resolve => {
      try {
        const __apiResult = await getProdDetail({
          withoutPrompting: true,
          data: {
            spuId,
            userId: userId || '',
            addrId: ''
          }
        })
                  resolve(true)
      } catch (errMsg) {
                  uni.showToast({
            title: errMsg.msg ? errMsg.msg : '商品已下架',
            icon: 'none'
          })
          resolve(false)
      }
    })
  },
  // 查询分销开关是否开启
  getDistSwitch () {
    return new Promise(async resolve => {
      try {
        const res = await getDistributionSysConfig({})
        resolve(res)
      } catch (error) {
                  resolve(-1)
      }
    })
  },
  // 处理分销页面跳转
  handleDistRedirect: async (link, loginRedirect) => {
    const domain = util.getDomain()
    const res = await util.isSaleMessage()
    const redirectMode = loginRedirect ? 'redirectTo' : 'navigateTo'
    if (+res.state === 1) {
      // 说明此人是分销员
      uni[redirectMode]({
        url: link
      })
    } else {
      // 否则该用户不是分销员
      if (res && res.state === 0) {
        uni.showToast({
          title: $t('distribution.applicationReview'),
          icon: 'none'
        })
      } else if (res && res.state === 3) {
        uni.showModal({
          title: '',
          content: $t('distribution.applicationFailed'),
          cancelText: $t('cancel'),
          confirmText: $t('confirm'),
          confirmColor: '#eb2444',
          success (res2) {
            if (res2.confirm) {
              if (res.recruitState) {
                uni[redirectMode]({
                  url: '/package-activities/pages/apply-distribution/apply-distribution'
                })
              } else {
                uni.navigateTo({
                  url: '/package-activities/pages/apply-distCon/apply-distCon'
                })
              }
            }
          }
        })
      } else if (res && res.state === -1) {
        uni.showModal({
          title: '',
          content: $t('distribution.distributorBanned'),
          confirmColor: '#eb2444',
          cancelText: $t('cancel'),
          confirmText: $t('confirm'),
          showCancel: false
        })
      } else if (res && res.state === 2) {
        uni.showModal({
          title: '',
          content: $t('distribution.distributorCleared'),
          confirmColor: '#eb2444',
          cancelText: $t('cancel'),
          confirmText: $t('confirm'),
          showCancel: false
        })
      } else if (+res.recruitState === 1) {
        // 开启了邀请页
        uni[redirectMode]({
          url: '/package-activities/pages/apply-distribution/apply-distribution' + (uni.getStorageSync(domain) ? '' : '&tid=' + tid)
        })
      } else if (+res.recruitState === 0) {
        // 关闭开启页
        uni[redirectMode]({
          url: '/package-activities/pages/apply-distCon/apply-distCon' + (uni.getStorageSync(domain) ? '' : '&tid=' + tid)
        })
      }
    }
  },
  /*
   分销接口
  */
  isSaleMessage: () => {
    return new Promise(async resolve => {
      const params = {}
      try {
        const res = await getDistributionUserInfo(params)
        resolve(res)
      } catch (error) {
        handleRequestError(error)
      }
    })
  },
  /*
   获取店铺信息
  */
  getShopMessage: shopId => {
    return new Promise(async resolve => {
      const params = {
        data: {
          shopId,
          imgType: 0 // 图片类型：0.app(h5) 1.pc
        }
      }
      try {
        const res = await getShopHeaderInfo(params)
        resolve(res)
      } catch (error) {
        handleRequestError(error)
      }
    })
  },
  // 小于10的格式化函数
  timeFormat: times => {
    return times < 10 ? '0' + times : times
  },
  dateToTimestamp: dateStr => {
    if (!dateStr) {
      return ''
    }
    const newDataStr = dateStr.replace(/\.|-/g, '/')
    const date = new Date(newDataStr)
    return date.getTime()
  },
  // 检查是否授权
  checkAuthInfo: (fn, redirectInfo) => {
    let domain = null
    // #ifdef H5
    const currentUrl = window.location.href
    const link = document.createElement('a')
    link.href = currentUrl
    // 获取域名
    domain = window.location.protocol + '//' + link.hostname
    // #endif
    uni.hideLoading()
    redirectInfo ? uni.setStorageSync('cloudFeatureRouteUrlAfterLogin', redirectInfo) : uni.removeStorageSync('cloudFeatureRouteUrlAfterLogin')
    const pages = getCurrentPages()
    uni.setStorageSync('cloudRouteUrlAfterLogin', pages.length ? pages[pages.length - 1].$page.fullPath : '/pages/index/index')
    if (uni.getStorageSync('cloudToken')) {
      fn()
      return
    }
    if (pages[0] && pages[pages.length - 1].route === 'pages/cart/cart') {
      return
    }
    uni.navigateTo({
      url: '/package-user/pages/user-login/user-login' + (uni.getStorageSync(domain) ? '' : uni.getStorageSync(domain) ? '' : '?tid=' + tid)
    })
  },
  // 函数参数必须是字符串，因为二代身份证号码是十八位，而在javascript中，十八位的数值会超出计算范围，造成不精确的结果，导致最后两位和计算的值不一致，从而该函数出现错误。
  // 详情查看javascript的数值范围
  checkIDCard: idcode => {
    // 加权因子
    const weightFactor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
    // 校验码
    const checkCode = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']
    const code = idcode + ''
    const last = idcode[17] // 最后一位

    const seventeen = code.substring(0, 17)

    // ISO 7064:1983.MOD 11-2
    // 判断最后一位校验码是否正确
    const arr = seventeen.split('')
    const len = arr.length
    let num = 0
    for (let i = 0; i < len; i++) {
      num = num + arr[i] * weightFactor[i]
    }

    // 获取余数
    const resisue = num % 11
    const lastNo = checkCode[resisue]

    // 格式的正则
    // 正则思路
    /*
    第一位不可能是0
    第二位到第六位可以是0-9
    第七位到第十位是年份，所以七八位为19或者20
    十一位和十二位是月份，这两位是01-12之间的数值
    十三位和十四位是日期，是从01-31之间的数值
    十五，十六，十七都是数字0-9
    十八位可能是数字0-9，也可能是X
    */
    const idcardPatter = /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/

    // 判断格式是否正确
    const format = idcardPatter.test(idcode)

    // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码
    return !!(last === lastNo && format)
  },
  /**
   * 手机号正则校验
   */
  checkPhoneNumber: phoneNumber => {
    // var regexp = /^[1]([3-9])[0-9]{9}$/
    const regexp = /^[1][0-9]{10}$/
    return regexp.test(phoneNumber)
  },
  /**
   * 邮箱正则校验
   */
  checkEmail: email => {
    const regexp = /^(\w+((-\w+)|(\.\w+))*)\+\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$ /
    return regexp.test(email)
  },
  /**
   * 用户名正则校验：①4-16位字母、数字或下划线； ②不允许纯数字
   * @param {String} userName
   */
  checkUserName: userName => {
    const regexp = /^(?!\d+$)[a-zA-Z0-9_]{4,16}$/
    return regexp.test(userName)
  },
  /**
   * 登录密码校验: 由字母加数字或符号至少两种以上字符组成6-20位半角字符，区分大小写
   * @param {String} password
   */
  checkPassword: password => {
    // var regexp = /^(?!\d+$)(?![a-zA-Z]+$)[0-9A-Za-z\W]{6,20}$/
    // return regexp.test(password)
    return password.length >= 6 && password.length <= 16
  },
  /**
   * 包含符号、空格
   * @param {String} value
   * @returns
   */
  containsSymbols: value => {
    const regexp = /[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、 ]/
    return regexp.test(value)
  },
  /**
   * 匹配两侧空格，匹配到就返回true
   * @param {String} str
   * @returns {Boolean}
   */
  noSpacesBothSides: str => {
    const reg = /(^\s)|(\s$)/g
    return reg.test(str)
  },
  /**
   * 获取链接上的参数
   */
  getUrlKey: name => {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || ['', ''])[1].replace(/\+/g, '%20')) || null
  },
  /**
   * 记录页面点击
   * @param {Number} visitType 访问类型 1:页面访问  2:加购  3:收藏  4:提交订单  5:支付成功  6:申请退款
   * @param {Object} params 参数 pid:页面id bid:业务id  n:加购商品的数量  sid:店铺id
   */
  tapLog: (visitType, {
    pid,
    bid,
    sid,
    n
  }) => {
    const flowAnalysisLogDtoUni = uni.getStorageSync('cloudFlowAnalysisLogDtoUni') || {}
    flowAnalysisLogDtoUni.n = n
    flowAnalysisLogDtoUni.bid = bid
    flowAnalysisLogDtoUni.sid = sid
    // 处理生成订单页面的pid
    if (pid) {
      let step = uni.getStorageSync('cloudStep') * 1
      step += 1
      flowAnalysisLogDtoUni.s = step
      uni.setStorageSync('cloudStep', step)
      flowAnalysisLogDtoUni.pid = pid
    }
    visitType = visitType || 1
    http.saveLog(visitType, flowAnalysisLogDtoUni)
  },
  /**
   * 获取唯一值
   */
  getUuid: () => {
    const s = []
    const hexDigits = '0123456789abcdef'
    for (let i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    }
    s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = '-'
    return s.join('')
  },
  /**
   * 时间戳与当前时间比较，是否为同一天
   */
  checkSameDay: timestamp => {
    const nt = new Date(new Date().getTime())
    const ot = new Date(timestamp)
    return ot.getFullYear() + ot.getMonth() + ot.getDate() === nt.getFullYear() + nt.getMonth() + nt.getDate()
  },
  /**
   * 函数节流
   * @param fn
   * @param wait
   * @returns {Function}
   * @constructor
   */
  throttle: (fn, wait) => {
    let timer = null
    return function () {
      const context = util
      const args = arguments
      if (!timer) {
        timer = setTimeout(function () {
          fn.apply(context, args)
          timer = null
        }, wait)
      }
    }
  },
  /**
   * 时间戳转化为年 月 日 时 分 秒
   * number: 传入时间戳
   * format：返回格式，支持自定义，但参数必须与formateArr里保持一致
   */
  tsToDate: (number, format) => {
    const formateArr = ['Y', 'M', 'D', 'h', 'm', 's']
    const returnArr = []
    const date = new Date(number)
    returnArr.push(date.getFullYear())
    returnArr.push(date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
    returnArr.push(date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
    returnArr.push(date.getHours() < 10 ? '0' + date.getHours() : date.getHours())
    returnArr.push(date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
    returnArr.push(date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
    for (const i in returnArr) {
      format = format.replace(formateArr[i], returnArr[i])
    }
    return format
  },
  /**
   * 进行相隔时间判断
   *
   * true 删除显示时间
   * false 保留显示时间
   */
  timeBeApart: (uppTime, preTime) => {
    if (!uppTime) {
      return false
    }
    const dateDiff = preTime - uppTime // 时间差的毫秒数
    const dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)) // 计算出相差天数
    const leave1 = dateDiff % (24 * 3600 * 1000) // 计算天数后剩余的毫秒数
    const hours = Math.floor(leave1 / (3600 * 1000)) // 计算出小时数
    // 计算相差分钟数
    const leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
    const minutes = Math.floor(leave2 / (60 * 1000)) // 计算相差分钟数

    return !(dayDiff >= 1 || hours >= 1 || minutes > 4)
  },
  /**
   * tabbar国际化
   */
  transTabbar: () => {
    uni.setTabBarItem({
      index: 0,
      text: $t('index.homepage')
    })
    uni.setTabBarItem({
      index: 1,
      text: $t('index.classification')
    })
    // 条件编译：非小程序端，保留 直播、购物车、我的 3个tab
    // #ifndef MP-WEIXIN
    uni.setTabBarItem({
      index: 2,
      text: $t('tabbarLive')
    })
    uni.setTabBarItem({
      index: 3,
      text: $t('cart')
    })
    uni.setTabBarItem({
      index: 4,
      text: $t('myself')
    })
    // #endif

    // 条件编译：小程序端移除 直播tab，保留 购物车、我的
    // #ifdef MP-WEIXIN
    uni.setTabBarItem({
      index: 2,
      text: $t('cart')
    })
    uni.setTabBarItem({
      index: 3,
      text: $t('myself')
    })
    // #endif
  },
  /**
   * 精度运算
   * @param {*} a 第一个计算数(例如:被除数/被减数)
   * @param {*} b 第二个计算数(例如:除数/减数)
   * @param {*} countMode 计算方式(0:加 1:减 2:乘 3:除)
   */
  accuracyCount: (a, b, countMode) => {
    let finalResult = 0
    if (countMode === 0) {
      finalResult = new Big(a).plus(b).valueOf()
    } else if (countMode === 1) {
      finalResult = new Big(a).minus(b).valueOf()
    } else if (countMode === 2) {
      finalResult = new Big(a).times(b).valueOf()
    } else if (countMode === 3) {
      finalResult = new Big(a).div(b).valueOf()
    } else {
      return
    }
    return finalResult
  },
  /**
   * 倒计时计算
   * @param {*} seconds 在几秒后失效
   */
  countDown: seconds => {
    if (!seconds) {
      return ''
    }
    // 计算日期
    const day = parseInt(seconds / (60 * 60 * 24))
    const hour = parseInt(seconds % (60 * 60 * 24) / 3600)
    const min = parseInt(seconds % (60 * 60 * 24) % 3600 / 60)
    const sec = parseInt(seconds % (60 * 60 * 24) % 3600 % 60)
    return {
      day: `${util.timeFormat(day)}`,
      hour: `${util.timeFormat(hour)}`,
      min: `${util.timeFormat(min)}`,
      sec: `${util.timeFormat(sec)}`
    }
  },
  /**
   * 登录成功
   * @param {Object} loginRes 登录成功返回的数据
   * @param {Boolean} isRefreshToken 该次登录是否为刷新token;
   */
  loginSuccess: async function (loginRes, isRefreshToken) {
    // 移除附近定位信息
    uni.removeStorageSync('cloudNearbyLocationInfo')
    uni.setStorageSync('cloudToken', loginRes.accessToken)
    uni.setStorageSync('cloudLoginResult', loginRes) // 保存整个登录数据
    const expiresTimeStamp = loginRes.expiresIn * 1000 / 2 + new Date().getTime()
    // 缓存token的过期时间
    uni.setStorageSync('cloudExpiresTimeStamp', expiresTimeStamp)
    // 请求用户信息
    const userInfo = await this.getUserInfo()
    uni.setStorageSync('cloudUserDetails', userInfo)

    // 还原全局 正在登录状态
    util.resetLoginSts()
    // 请求购物车数量
    cartCount.getCartCount()

    // 登录成功后，更新通联支付配置
    util.getAllinpayConfig()

    // 若为刷新token的登录，则不需要跳转到上一页面
    if (isRefreshToken) {
      // console.log('刷新token登录成功，不需要跳转到上一页面')
      return
    }
    getApp().globalData.reloadHomePopupAd = true // 重新加载首页弹窗广告
    getApp().globalData.reloadPageData = true
    // 装修页面跳转
    const featureRouteUrlAfterLogin = uni.getStorageSync('cloudFeatureRouteUrlAfterLogin')
    if (featureRouteUrlAfterLogin) {
      uni.removeStorageSync('cloudFeatureRouteUrlAfterLogin')
      if (featureRouteUrlAfterLogin.startsWith('/package-activities/pages/distribution-center/distribution-center')) {
        // 用户跳转去分销中心
        util.handleDistRedirect(featureRouteUrlAfterLogin, 1)
        return
      }
      uni.redirectTo({
        url: featureRouteUrlAfterLogin
      })
      return
    }
    const routeUrlAfterLogin = uni.getStorageSync('cloudRouteUrlAfterLogin')
    const pages = getCurrentPages()

    // 如果是该数组的页面，则不跳转回首页
    const pageNoJumpList = [PRODUCT_DETAIL_ROUTE,
      FLASH_PRODUCT_DETAIL_ROUTE,
    // 商品详情页
      'package-activities/pages/group-detail/group-detail',
      // 拼团详情页
      'package-activities/pages/binding-relationship/binding-relationship' // 分销员关系绑定页
    ]
    const nowRoute = pages[pages.length - 1].route
    if (pageNoJumpList.some(item => item === nowRoute)) {
      // 如果当前页面是商品详情页或拼团详情页，则不跳转其它页面
      return
    }
    const prevPage = pages[pages.length - 2]
    if (!prevPage) {
      // 当前页面为首页、订单列表，不跳转首页；如果是订单列表，可能是微信发货小程序点进来的，所以不要跳转了
      if (pages[pages.length - 1].route === 'pages/index/index' || pages[pages.length - 1].route === 'package-user/pages/order/order') {
        return
      }
      uni.switchTab({
        url: '/pages/index/index'
      })
      return
    }
    // 判断上一页面是否为tabbar页面 (首页和分类页无需登录接口)
    const isTabbar = prevPage.route === 'pages/user/user' || prevPage.route === 'pages/basket/basket'
    if (prevPage.route === 'package-activities/pages/live-room/live-room' || prevPage.route === 'package-activities/pages/wx-player/wx-player') {
      uni.setStorageSync('cloudLiveRoomReload', true)
    }
    if (isTabbar) {
      uni.switchTab({
        url: '/' + prevPage.route
      })
    } else {
      // 非tabbar页面
      let backDelata = 0
      pages.forEach((page, index) => {
        if (page.$page.fullPath === routeUrlAfterLogin) {
          backDelata = pages.length - index - 1
        }
      })
      if (backDelata) {
        uni.navigateBack({
          delta: backDelata
        })
      } else {
        uni.switchTab({
          url: '/pages/index/index'
        })
      }
    }
  },
  getUserInfo: () => {
    // eslint-disable-next-line no-unused-vars
    return new Promise(async (resolve, reject) => {
      try {
        const res = await getUserDetailInfo({
          dontTrunLogin: true
        })
        resolve(res)
      } catch (error) {
        handleRequestError(error)
      }
    })
  },
  /**
   * 刷新token
   */
  refreshToken: async () => {
    const refreshToken = uni.getStorageSync('cloudLoginResult').refreshToken
    const expiresTimeStamp = uni.getStorageSync('cloudExpiresTimeStamp')
    if (refreshToken && expiresTimeStamp && expiresTimeStamp < new Date().getTime()) {
      getApp().globalData.isLanding = true
      const params = {
        isRefreshing: true,
        data: {
          refreshToken
        }
      }
      try {
        const res = await refreshAccessToken(params)
        util.resetLoginSts()
        util.loginSuccess(res, true)
      } catch (error) {
                  uni.hideLoading()
          util.resetLoginSts()
          // 清除refreshToken 过期时间
          uni.removeStorageSync('cloudExpiresTimeStamp')
      }
    }
  },
  /**
   * 获取并更新通联支付配置信息
   */
  getAllinpayConfig: async () => {
    const params = {}
    try {
      const res = await getPaySettlementTypeConfig(params)
      if (res) {
        const paySettlementType = JSON.parse(res).paySettlementType
        uni.setStorageSync('cloudPaySettlementType', paySettlementType)
        if (paySettlementType === 1) {
          // 通联支付已开启，则获取用户是否创建通联会员
          util.getAllinpayMember()
        }
      }
    } catch (error) {
      handleRequestError(error)
    }
  },
  /**
   * 获取用户是否创建通联会员
   */
  getAllinpayMember: () => {
    const params = {
      withoutPrompting: true
    }
    getAllinpayMemberInfo(params).catch(res => {
      if (res.msg === '用户不存在。') {
        util.createAllinpayMember()
      }
    })
  },
  /**
   * 创建通联会员
   */
  createAllinpayMember: () => {
    const params = {}
    createAllinpayMember(params)
  },
  /**
   * 防抖
   * @param fn
   * @param t
   * @returns {Function}
   */
  debounce: (fn, t) => {
    const delay = t || 300
    let timer
    return function () {
      const args = arguments
      if (timer) {
        console.error('debounce 触发了前端请求防抖，请等待' + delay + '毫秒后点击')
        clearTimeout(timer)
      }
      const callNow = !timer
      timer = setTimeout(() => {
        timer = null
      }, delay)
      if (callNow) fn.apply(util, args)
    }
  },
  /**
   * 微信环境登录
   */
  weChatLogin: () => {
    const appType = uni.getStorageSync('cloudAppType')
    const domainAddress = uni.getStorageSync('cloudAppDetailUrl') || {}
    if (appType !== AppType.MP && appType !== AppType.MINI) {
      return
    }
    if (appType === AppType.MINI) {
      wx.login({
        success: res => {
          util.loginByCode(res.code) // 小程序-先请求微信小程序登录接口
        }
      })
      return
    }
    if (appType === AppType.MP) {
      const tempuid = uni.getStorageSync('cloudTempUidCloud')
      const token = uni.getStorageSync('cloudToken')
      if (!tempuid && !token) {
        // alert('公众号网页登录location.href:' + location.href)
        const code = util.getUrlKey('code')
        if (!code) {
          http.mpAuthLogin(domainAddress.h5Url, true)
          return
        }
        // alert('H5-微信环境 code:' + code)
        util.loginByCode(code) // 先请求微信公众号登录接口
      }
    }
  },
  /**
   * 通过微信返回的code登录
   * @param {String} code 请求微信返回的 code
   */
  loginByCode: async code => {
    const params = {
      login: true,
      data: code
    }
    try {
      const loginBySocial = uni.getStorageSync('cloudAppType') === AppType.MINI ? loginBySocialMa : loginBySocialMp
      const res = await loginBySocial(params)
      uni.setStorageSync('cloudTempUidCloud', res.tempUid)
      if (res.tokenInfo) {
        util.loginSuccess(res.tokenInfo)
      }
    } catch (errRes) {
      if (errRes.code === 'A04001') {
        // 还原全局 正在登录状态
        util.resetLoginSts()
        uni.setStorageSync('cloudTempUidCloud', errRes.data) // token或tempUid
      }
    }
  },
  /**
   * 还原登录状态
   */
  resetLoginSts: () => {
    getApp().globalData.isLanding = false
    while (getApp().globalData.requestQueue.length) {
      apiRequest(getApp().globalData.requestQueue.pop())
      getApp().globalData.currentReqCounts--
    }
  },
  /**
   * 设置默认支付类型
   * @param {String} payTypeStr aliPay支付宝   wechatPay微信支付   balancePay余额支付
   * @return {Number} payType 支付类型
   */
  setDefaultPayType: payTypeStr => {
    if (!payTypeStr) return ''
    const isWechat = uni.getStorageSync('cloudAppType') === AppType.MP || uni.getStorageSync('cloudAppType') === AppType.MINI
    let payType
    if (payTypeStr === 'balancePayStatus') {
      payType = PayType.BALANCEPAY
    } else if (payTypeStr === 'paypalStatus') {
      payType = PayType.PAYPAL
    } else if (payTypeStr === 'cardPayStatus') {
      payType = PayType.CARDPAY
    } else {
      const paySettlementType = uni.getStorageSync('cloudPaySettlementType')
      // #ifdef H5
      payType = payTypeStr === 'aliPayStatus' ? PayType.ALIPAY_H5 : isWechat ? PayType.WECHATPAY_MP : PayType.WECHATPAY_H5

      // #endif
      // #ifdef APP-PLUS
      if (paySettlementType === 1) {
        payType = payTypeStr === 'aliPayStatus' ? PayType.ALIPAY_H5 : PayType.WECHATPAY_APP
        return payType
      }
      payType = payTypeStr === 'aliPayStatus' ? PayType.ALIPAY_APP : PayType.WECHATPAY_APP
      // #endif
      // #ifdef MP-WEIXIN
      payType = PayType.WECHATPAY
      // #endif
    }
    return payType
  },
  /**
   * @param {object} payConfig 支付配置
   * @param {Boolean} isRecharge 余额重置
   */
  setDefaultPayTypeStr: (payConfig, isRecharge) => {
    const appType = uni.getStorageSync('cloudAppType')
    const paySettlementType = uni.getStorageSync('cloudPaySettlementType')
    const {
      aliPayStatus,
      wxPayStatus,
      paypalStatus,
      balancePayStatus
    } = payConfig
    if (appType > 2 && aliPayStatus) {
      return 'aliPayStatus'
    } else if (wxPayStatus && appType < 7) {
      return 'wxPayStatus'
    } else if (paypalStatus) {
      let paypalStatus
      paypalStatus = 'paypalStatus'
      // #ifdef MP-WEIXIN
      // 微信小程序不适用paypal支付
      paypalStatus = ''
      // #endif
      return paypalStatus
    } else if (!isRecharge && balancePayStatus) {
      return 'balancePayStatus'
    }
    // #ifdef APP-PLUS
    if (paySettlementType === 1) {
      if (appType > 2 && aliPayStatus) {
        // 通联支付下，app中只有支付宝支付
        return 'aliPayStatus'
      } else {
        return ''
      }
    }
    // #endif
    return ''
  },
  /**
   * minIo 上传文件
   * @param imgItem
   * @param {Object} fn 上传成功回调
   */
  mioIoUpload: (imgItem, fn) => {
    const params = getUploadMinioOptions({
      filePath: imgItem,
      name: 'file',
      callBack: res => {
        const data = JSON.parse(res).data
        const resourcesVal = '/' + data.dir + data.fileName
        fn(resourcesVal)
      }
    })
    http.upload(params)
  },
  /**
   * 根据地址返回省市区
   * @param {String} address 地址
   * @param {String} name 地名
   * @return {Array} 省市区的信息
   */
  area: async (address, name) => {
    if (!address) return
    const areaInfoArr = []
    let province, city, area // 名字
    let provinceIndex, cityIndex, areaIndex // 所处的索引
    let provinceId, cityId, areaId // areaId
    // 特殊的区域
    if (name.includes('苏滁现代产业园')) {
      province = '安徽省'
      city = '苏滁市'
      area = '苏滁现代产业园'
    } else if (name.includes('保定白沟新城')) {
      province = '河北省'
      city = '保定市'
      area = '保定白沟新城'
    } else if (name.includes('中沙群岛')) {
      province = '海南省'
      city = '三沙市'
      area = '中沙群岛的岛礁及其海域'
    } else {
      const provSuffix = ['省', '自治区', '黑龙江', '北京市', '天津市', '上海市', '重庆市']
      const citySuffix = ['市', '地区', '自治州', '盟']
      const areaSuffix = ['区', '县', '市', '群岛']
      let aIndex = 0
      const common = arr => {
        aIndex = 0
        // 找出所有后缀在 address 中的最早出现位置，优先使用最靠前的匹配
        let earliest = -1
        let earliestSuffix = ''
        for (let i = 0; i < arr.length; i++) {
          const idx = address.indexOf(arr[i])
          if (idx !== -1) {
            if (earliest === -1 || idx < earliest) {
              earliest = idx
              earliestSuffix = arr[i]
            }
          }
        }
        if (earliest !== -1) {
          aIndex = earliest + earliestSuffix.length
        }
      }
      common(provSuffix)
      if (aIndex === 0) return
      province = address.substring(0, aIndex)
      address = address.substring(aIndex)
      // 直辖市
      if (province === '北京市' || province === '天津市' || province === '上海市' || province === '重庆市') {
        for (const itAddr of ['北京市', '天津市', '上海市', '重庆市']) {
          const inx = address.indexOf(itAddr)
          if (inx !== -1) {
            city = itAddr
            address = address.substring(itAddr.length)
            break
          }
        }
        common(areaSuffix)
        if (aIndex === 0) return
        area = address.substring(0, aIndex)
        city = area.includes('县') ? '县' : '市辖区'
      } else {
        common(citySuffix)
        if (aIndex === 0) return
        city = address.substring(0, aIndex)
        address = address.substring(aIndex)
        common(areaSuffix)
        if (aIndex === 0) return
        area = address.substring(0, aIndex)
      }
    }
    const getListByPid = pid => {
      return new Promise(async resolve => {
        const params = {
          data: {
            pid
          }
        }
        try {
          const res = await listAreaByParentId(params)
          resolve(res)
        } catch (error) {
          handleRequestError(error)
        }
      })
    }
    // 省
    // console.log(uni.getStorageSync('cloudProvArray'))
    if (!uni.getStorageSync('cloudProvArray')) {
      const params = {
        data: {}
      }
      try {
        const res = await listAreaOptions(params)
        if (res) {
          uni.setStorageSync('cloudProvArray', res)
        }
      } catch (error) {
        handleRequestError(error)
      }
    }
    if (uni.getStorageSync('cloudProvArray')) {
      const res1 = uni.getStorageSync('cloudProvArray')
      for (let i = 0; i < res1.length; i++) {
        if (province === res1[i].areaName) {
          provinceIndex = i
          provinceId = res1[i].areaId
          break
        }
      }
    } else {
      return []
    }
    // 市
    const res2 = await getListByPid(provinceId)
    for (let i = 0; i < res2.length; i++) {
      if (city === res2[i].areaName) {
        cityIndex = i
        cityId = res2[i].areaId
        break
      }
    }
    // 区
    const res3 = await getListByPid(cityId)
    for (let i = 0; i < res3.length; i++) {
      if (area === res3[i].areaName) {
        areaIndex = i
        areaId = res3[i].areaId
        break
      }
    }
    areaInfoArr.push({
      name: province,
      index: provinceIndex,
      areaId: provinceId
    })
    areaInfoArr.push({
      name: city,
      index: cityIndex,
      areaId: cityId
    })
    areaInfoArr.push({
      name: area,
      index: areaIndex,
      areaId
    })
    return areaInfoArr
  },
  /**
   * 回到首页
   */
  toHomePage: () => {
    const appType = uni.getStorageSync('cloudAppType')
    if (appType === 2 || appType === 4) {
      uni.switchTab({
        url: '/'
      })
    } else {
      uni.switchTab({
        url: '/pages/index/index'
      })
    }
  },
  /**
   * 微信小程序跳转通联小程序
   */
  toAllinPay: params => {
    wx.navigateToMiniProgram({
      appId: 'wxc46c6d2eed27ca0a',
      // 通联小程序 appId
      path: 'pages/merchantAddress/merchantAddress',
      // 通联小程序页面路径
      extraData: {
        targetUrl: params.targetUrl
      },
      // 商户拼接的请求报文
      envVersion: 'release',
      // develop 开发版 trial 体验版 release 正式版
      // 打开成功
      success: params.success,
      // 打开失败
      fail: params.fail,
      // 打开完成(成功或失败都会执行)
      complete: params.complete
    })
  },
  /**
   * 文件地址校验
   * @param fileUrl 获取到的文件路径
   */
  checkFileUrl: fileUrl => {
    if (fileUrl === '') return ''
    const baseUrl = import.meta.env.VITE_APP_RESOURCES_URL
    if (fileUrl && fileUrl.indexOf('http') === -1) {
      return baseUrl + fileUrl
    } else {
      return fileUrl
    }
  },
  // 生成海报
  getPoster: (pic, price, prodName, code) => {
    return {
      css: {
        width: '600rpx',
        height: '850rpx'
      },
      views: [{
        type: 'view',
        css: {
          width: '600rpx',
          height: '850rpx',
          position: 'fixed',
          backgroundColor: '#fff',
          borderRadius: '24rpx',
          padding: '30rpx',
          boxSizing: 'border-box'
        },
        views: [{
          type: 'image',
          // 这个是默认图片，路径错误会导致小程序生成失败
          src: '/static/images/def.png',
          css: {
            width: '540rpx',
            height: '540rpx',
            display: 'block',
            margin: '0 auto'
          }
        }, {
          type: 'image',
          src: util.checkFileUrl(pic),
          css: {
            width: '540rpx',
            height: '540rpx',
            display: 'block',
            position: 'absolute',
            top: '-30rpx',
            left: '-30rpx',
            objectFit: 'cover'
          }
        }, {
          type: 'view',
          css: {
            height: '200rpx',
            width: '540rpx',
            marginTop: '50rpx'
          },
          views: [{
            type: 'view',
            css: {
              width: '360rpx',
              height: '190rpx',
              borderRight: '1px solid #E9E9EA'
            },
            views: [{
              type: 'view',
              css: {},
              views: [{
                type: 'text',
                text: '￥',
                css: {
                  fontSize: '28rpx',
                  color: '#f81a1a',
                  verticalAlign: 'bottom'
                }
              }, {
                type: 'text',
                text: wxs.parsePrice(price)[0] + '.',
                css: {
                  fontSize: '40rpx',
                  verticalAlign: 'bottom',
                  lineHeight: '40rpx',
                  color: '#f81a1a'
                }
              }, {
                type: 'text',
                text: wxs.parsePrice(price)[1],
                css: {
                  fontSize: '28rpx',
                  verticalAlign: 'bottom',
                  color: '#f81a1a'
                }
              }]
            }, {
              type: 'text',
              text: prodName,
              css: {
                marginTop: '10rpx',
                fontSize: '28rpx',
                color: '#333333',
                display: '-webkit-box',
                boxOrient: 'vertical',
                lineClamp: 4,
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }
            }]
          }, {
            type: 'view',
            css: {
              width: '150rpx',
              height: '150rpx',
              position: 'absolute',
              right: '0rpx',
              bottom: '30rpx'
            },
            views: [{
              type: 'image',
              src: code,
              css: {
                width: '150rpx',
                height: '150rpx'
              }
            }]
          }, {
            type: 'text',
            text: '长按识别查看',
            css: {
              fontSize: '20rpx',
              lineHeight: '30rpx',
              textAlign: 'center',
              width: '150rpx',
              height: '30rpx',
              position: 'absolute',
              right: '0rpx',
              bottom: '0rpx'
            }
          }]
        }]
      }]
    }
  },
  /**
   * 小程序处理base64小程序码
   * @param {*} base64data
   */
  base64src: (base64data, flag = false) => {
    const fsm = uni.getFileSystemManager()
    let mimeType = null
    let arr = []
    if (flag) {
      arr = base64data.split(',')
      mimeType = arr[0].match(/:(.*?);/)[1] // 获取 mime 类型，例如 image/png
    }
    const FILE_BASE_NAME = 'tmp_base64src' + Math.random() * 1000000000000
    return new Promise((resolve, reject) => {
      const format = 'jpg'
      const bodyData = base64data
      if (!format) {
        reject(new Error('ERROR_BASE64SRC_PARSE'))
      }
      const filePath = `${wx.env.USER_DATA_PATH}/${FILE_BASE_NAME}.${flag ? mimeType.split('/')[1] : format}`
      const buffer = uni.base64ToArrayBuffer(flag ? arr[1] : bodyData)
      fsm.writeFile({
        filePath,
        data: buffer,
        encoding: 'binary',
        success () {
          resolve(filePath)
        },
        fail () {
          reject(new Error('ERROR_BASE64SRC_WRITE'))
        }
      })
    })
  },
  gotoLiveRoom (roomId) {
    const domain = util.getDomain()
    const tid = uni.getStorageSync('cloudTid')
    util.videoInteract()
    uni.removeStorageSync('cloudBarrageList') // 清除缓存的弹幕信息
    uni.navigateTo({
      url: `/package-activities/pages/live-room/live-room?roomId=${roomId}` + (uni.getStorageSync(domain) ? '' : `&tid=${tid}`)
    })
  },
  videoInteract () {
    // #ifdef H5
    if (getApp().globalData.$isVideoInteract) return
    const audioObj = uni.createInnerAudioContext()
    audioObj.src = media
    audioObj.play()
    audioObj.stop()
    audioObj.destroy()
    getApp().globalData.$isVideoInteract = true
    // #endif
  },
  saveImageToPhotosAlbum (filePath, callback) {
    checkAuthorize('writeStorage', {
      success: () => {
        uni.saveImageToPhotosAlbum({
          filePath,
          success: () => {
            // 回调函数放在最前面，防止回调中执行隐藏loading加载，导致真机小程序showToast显示时间太短问题
            callback && callback()
            setTimeout(() => {
              uni.showToast({
                icon: 'none',
                mask: true,
                title: '已保存至相册'
              })
            }, 1)
          },
          fail: () => {
            uni.showToast({
              icon: 'none',
              mask: true,
              title: '保存失败'
            })
          }
        })
      }
    })
  },
  /**
   * 获取弹窗信息
   * @param {Object} data
   * @param {Number} data.pageType 触发页面类型 1.平台首页 2.会员中心 3.支付成功 4.店铺首页 5.商品详情
   * @param {Number} data.shopId  店铺id 平台为0
   * @returns {Promise} 返回一个promise，弹窗广告信息
   */
  getPopupInfo: async data => {
    // 游客uuid 未登录时必传
    if (!uni.getStorageSync('cloudOid')) {
      // eslint-disable-next-line require-atomic-updates
      data.uuid = await http.getOid()
    } else {
      data.uuid = uni.getStorageSync('cloudOid')
    }
    return new Promise(async (resolve, reject) => {
      try {
        const res = await triggerCostPerPopup({
          data
        })
        // 1-未开始 2-投放中 3-已结束
        resolve(res?.status === 2 ? res : null)
      } catch (err) {
                  reject(err)
      }
    })
  },
  // 获取域名
  getDomain: () => {
    let domain
    // #ifdef H5
    const link = document.createElement('a')
    link.href = window.location.href
    domain = window.location.protocol + '//' + link.hostname
    // #endif
    // #ifndef H5
    domain = null
    // #endif
    return domain
  },
  // 设置附近定位缓存
  setNearbyLocation: data => {
    uni.setStorageSync('cloudNearbyLocationInfo', data)
  },
  /**
   * 获取定位信息，用于门店相关的经纬度需要
   * @param {Function} callback 回调函数
   * @param {Boolean} isAltitude 是否开启高精度定位
   */
  afreshGetLocation: (callback, isAltitude) => {
    let options = {}
    if (isAltitude) {
      options = {
        altitude: true,
        isHighAccuracy: true,
        highAccuracyExpireTime: 3500
      }
    }
    uni.getLocation({
      type: 'wgs84',
      // #ifdef APP-PLUS
      geocode: true,
      // #endif
      ...options,
      success: res => {
        const sourceLat = res.latitude
        const sourceLng = res.longitude
        const sourceAddress = res.address
        res = wgs84togcj02(res)
        res.sourceLat = sourceLat
        res.sourceLng = sourceLng
        res.address = sourceAddress
        callback && callback(res)
        uni.setStorageSync('cloudLocationInfo', {
          lat: res.latitude,
          lng: res.longitude,
          sourceLat,
          sourceLng
        })
      },
      fail: err => {
        // eslint-disable-next-line no-console
        console.log('定位失败', err)
        const locationInfo = uni.getStorageSync('cloudLocationInfo')
        callback && callback(locationInfo || {
          lat: 39.90,
          lng: 116.38,
          locationFailed: true
        })
      }
    })
  },
  backPrevPage () {
    // #ifndef H5
    uni.navigateBack({
      delta: 1
    })
    // #endif
    // #ifdef H5
    history.back()
    // #endif
  },
  // 清除用户缓存信息
  clearUserStorage () {
    uni.removeStorageSync('cloudNearbyLocationInfo')
    uni.removeStorageSync('cloudFlashDeliveryAddrInfo')
    uni.removeStorageSync('cloudToken')
    uni.removeStorageSync('cloudDistributionUserId')
    uni.removeStorageSync('cloudLoginResult')
    uni.removeStorageSync('cloudUserDetails')
    uni.removeStorageSync('cloudExpiresTimeStamp')
    uni.removeStorageSync('cloudDeliveryAddrInfo')
    uni.removeStorageSync('cloudOid') // 变更uuid (数据分析)
    http.getOid()
    getApp().globalData.reloadHomePopupAd = true // 重新加载首页弹窗广告
    getApp().globalData.reloadPageData = true // 重新加载页面数据
  },
  pageBack () {
    // #ifdef H5
    history.back()
    // #endif
    // #ifndef H5
    uni.navigateBack()
    // #endif
  },
  /**
   * 地图选择地点事件
   * @param {Function} fn 回调函数
   */
  selectLocation (fn) {
    checkAuthorize('location', {
      success: () => {
        // #ifdef H5 || APP-PLUS
        // 开启监听定位选点事件
        uni.$on('onGetLocation', function (data) {
          fn(data)
        })
        uni.navigateTo({
          url: '/package-user/pages/common-map/common-map?isSelect=1'
        })
        // #endif
        // #ifdef MP-WEIXIN
        uni.chooseLocation({
          success: res => {
            fn(res)
          }
        })
        // #endif
      }
    })
  },
  /**
   * 导航到指定位置（自提点）
   */
  navigateToLocation (locationInfo) {
    const address = locationInfo.address || locationInfo.addr
    const lat = locationInfo.lat || locationInfo.latitude
    const lng = locationInfo.longitude || locationInfo.lng
    const stationName = locationInfo.stationName || locationInfo.title
    if (!lat || !lng) {
      return
    }
    // #ifdef H5 || APP-PLUS
    uni.navigateTo({
      url: `/package-user/pages/common-map/common-map?stationInfo=${JSON.stringify({
        lat,
        lng,
        stationName,
        address
      })}`
    })
    // #endif

    // #ifdef MP-WEIXIN
    uni.openLocation({
      latitude: Number(lat),
      longitude: Number(lng),
      name: stationName,
      address
    })
    // #endif
  },
  /**
   * 设置应用类型
   */
  setAppType () {
    // #ifdef H5
    uni.setStorageSync('cloudAppType', AppType.H5) // 普通H5
    const ua = navigator.userAgent.toLowerCase()
    if (ua.search(/MicroMessenger/i) > -1) {
      // 微信环境
      uni.setStorageSync('cloudAppType', AppType.MP)
    }
    // #endif
    // #ifdef APP-PLUS
    uni.getSystemInfo({
      success: sysInfo => {
        if (sysInfo.platform === 'android') {
          uni.setStorageSync('cloudAppType', AppType.ANDROID)
        } else {
          uni.setStorageSync('cloudAppType', AppType.IOS)
        }
      }
    })
    // #endif
    // #ifdef MP-WEIXIN
    uni.setStorageSync('cloudAppType', AppType.MINI)
    // #endif
  },
  /**
   * 递归移除对象或数组中值为 null 的键
   * @param {Object|Array} data - 要处理的数据
   * @param {Object} [options] - 配置选项
   * @param {boolean} [options.removeEmptyStrings=false] - 是否同时移除空字符串
   * @param {boolean} [options.removeUndefined=false] - 是否同时移除 undefined
   * @returns {Object|Array} 清理后的数据
   */
  deepRemoveNulls (data, options = {}) {
    const {
      removeEmptyStrings = false,
      removeUndefined = false
    } = options
    if (Array.isArray(data)) {
      return data.map(item => util.deepRemoveNulls(item, options)).filter(item => item !== null && !(removeUndefined && item === undefined))
    }
    // 检查是否为普通对象
    if (typeof data === 'object' && data !== null) {
      return Object.entries(data).reduce((acc, [key, value]) => {
        const cleanedValue = util.deepRemoveNulls(value, options)
        // 检查是否应该保留这个键值对
        const shouldRemove = cleanedValue === null || removeEmptyStrings && cleanedValue === '' || removeUndefined && cleanedValue === undefined
        if (!shouldRemove) {
          acc[key] = cleanedValue
        }
        return acc
      }, {})
    }
    return data
  }
}
export default util
